import { cosmosConfig } from "../constants/cosmos"
import { COSMOS_KEY } from "../entities/cosmos"

export default function getCosmosKey(): COSMOS_KEY {
  const hostname = window.location.hostname
  const parts = hostname.split(".")

  if (hostname === "localhost") return COSMOS_KEY.DEFAULT

  const isValidCosmosKey =
    parts.length > 2 && Boolean(cosmosConfig[parts.slice(0, -2).join(".") as COSMOS_KEY])

  const cosmosKey = isValidCosmosKey ? parts.slice(0, -2).join(".") : "default"
  return cosmosKey as COSMOS_KEY
}
